import { useContext, useState, useEffect } from 'react';
import AuthContext from './components/AuthContext';
import { Input, Label } from 'reactstrap';
import Alert from '@mui/material/Alert';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import MediaCard from './components/MediaCard';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import './css/styles.css';

export default function Unlock() {
  const {auth, setAuth, login, logout} = useContext(AuthContext);
  const [token, setToken] = useState(null);
  const [privacy, setPrivacy] = useState(false);
  // const [location, setLocation] = useState(null);
  const [errorMsg, setErrorMsg] = useState('');

  if (!auth) {
    throw new Error('AuthContext must be used within an AuthProvider');
  }
  const { isAuthenticated, loading, msg } = auth;

  useEffect(() => {
    const handleExternalAjax = (event) => {
      // console.log('External AJAX completed:', event.detail);
      // Update state or perform actions
    };

    document.addEventListener('Exit', handleExternalAjax);
    
    return () => {
      document.removeEventListener('Exit', handleExternalAjax);
    };
  }, []);

  // useEffect(() => {
  //   console.log("Updated location:", location);
  // }, [location]);

  // const handleLocation= (e) => {
  //   const { name, value } = e.target;
  //   setLocation(prev => ({
  //     ...prev,
  //     [name]: value
  //   }));
  //   // console.log(location);
  // }

  const handleCheck = (e) => {
    const { name, checked } = e.target;
    // if (checked){
    setAuth(prev => ({
      ...prev,
      msg: null
    }));
    // }
    setPrivacy(checked);
    // console.log(privacy)
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(privacy);
    if(privacy){
      // console.log("Form submitted!");
      await login({token});
    }
    // setPrivacy(false)
    // console.log(msg);
  };

  const handleTokenChange = (e) => {
    const { name, value } = e.target;

    setToken(prev => ({
      ...prev,
      [name]: value
    }));
  };

  if (loading) {
    return (
      // <div>Loading...</div>
      <div class="loading-overlay">
        <svg class="spinner" viewBox="0 0 50 50">
            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5" stroke-linecap="round"/>
        </svg>
      </div>
    )
  };

  return (
    <div
      style={{ textAlign: "center" }} 
    >
      {isAuthenticated ? (
        // <div>You're logged in!</div>
        <div class="loading-overlay">
          <svg class="spinner" viewBox="0 0 50 50">
              <circle cx="25" cy="25" r="20" fill="none" stroke-width="5" stroke-linecap="round"/>
          </svg>
        </div>
      ) : (
        <>
          <h2>Privacy Statement</h2>
          <div style={{justifyItems: "center", display: "grid"}} >
            <div className='scroll-box'>
              <MediaCard 
                width={"100vh"} 
                cardHeight={"10vh"}
                // buttons={{1: "Learn More"}}
              >
              <div class="">
                <p>Your privacy is important to us. This Expression of Interest (EOI) form collects your personal and health information for the sole purpose of determining your eligibility for a clinical trial conducted by Macquarie University and ISHCERF Centre.</p>
                <span style={{fontWeight: "bold"}}>We will:</span>
                <ul style={{listStyleType: 'none', margin: 0, padding: 0, textAlign: "start" }}>
                  <li style={{ display: 'flex', alignItems: 'center', margin: "5px" }}><InfoOutlineIcon sx={{ marginRight: 1 }}/>Only collect information that is necessary for assessing your suitability for the trial.</li>
                  <li style={{ display: 'flex', alignItems: 'center', margin: "5px" }}><InfoOutlineIcon sx={{ marginRight: 1 }}/>Store your data securely in compliance with the Australian Privacy Principles (APPs) under the Privacy Act 1988 (Cth).</li>
                  <li style={{ display: 'flex', alignItems: 'center', margin: "5px" }}><InfoOutlineIcon sx={{ marginRight: 1 }}/>Not share your information with any third parties without your explicit consent, unless required by law.</li>
                  <li style={{ display: 'flex', alignItems: 'center', margin: "5px" }}><InfoOutlineIcon sx={{ marginRight: 1 }}/>Retain your information only as long as necessary for clinical trial operations or with your permission for future studies.</li>
                </ul>
                <br/>
                <p>You can request access to or correction of your information by contacting our clinical trials team. If you choose not to proceed with the study at any point, your information will be securely deleted, unless required to be retained under clinical regulations.</p>
                <p>For further information or privacy concerns, contact:</p>
                <p style={{fontWeight: "bold"}}>Clinical Trials Coordinator</p>
                <p>Macquarie University Breast Implant Study</p>
                <br/><p>BRV-005@mq.edu.au</p>
                <p>Department Macquarie Plastic and Reconstructive Surgery. Suite 301, 2 Technology Place Macquarie Park, NSW 2109</p>
              </div>
              </MediaCard>
            </div>
          </div>
          <Input type="checkbox" name="privacy" onChange={handleCheck} style={{marginTop: "30px"}}/>
          <Label check className='unlock-text'>
             &nbsp;I acknowledge that I have read, understood, and agree to the privacy terms. 
          </Label>
          <form onSubmit={handleSubmit} style={{ textAlign: "center", justifyItems: "center", display: "grid" }}>
            <p className='unlock-text'>Please enter your authentication token below:</p>
            <input type="text" name="token" style={{ color: "black", margin: 0, marginBottom: "15px" }} onChange={handleTokenChange}/>
            {privacy ? (<>{msg?(<Alert variant="filled" severity="error" color="warning" style={{ maxWidth: "400px", margin: 0, marginBottom: "15px" }}><p>{msg}</p></Alert>): (<></>)}</>):
              <Alert variant="filled" severity="error" color="warning" style={{ maxWidth: "400px", margin: 0, marginBottom: "15px" }}>
                <p className='unlock-error-text'>You need to agree to the privacy terms.</p>
              </Alert>
            }
            <br/>
            <br/>
            <button type="submit">Authenticate</button>
          </form>
        </>
      )}
    </div>
  );
}
